export default "/images/cat-logo-3.png?0cc3b3903f039a46166ae083bf9d9f58";